import { GET_SIDEMENU_STATUS, TOGGLE_SIDEMENU } from '../constants/ActionTypes';

export const getSideMenuOpenStatusAction = function (dispatch) {
  dispatch({
    type: GET_SIDEMENU_STATUS,
  });
};

export const toggleSideMenu = function (model, dispatch) {
  dispatch({
    type: TOGGLE_SIDEMENU,
    payload: model,
  });
};
